export function deferExecution(callback: () => void, delay = 0) {
  return typeof requestIdleCallback === "function"
    ? requestIdleCallback(() => callback())
    : setTimeout(() => callback(), delay);
}

export function clearDeferredExecution(timeoutId: any) {
  if (timeoutId) clearTimeout(timeoutId);
}
